import React from "react";
import { Route, Routes } from 'react-router-dom'
import DriverBinding from "../pages/controle-carga/cdc-driver-binding/DriverBinding";
import ManagementPanel from "../pages/controle-carga/cdc-management-panel/ManagementPanel";




const ManagementPanelRoutes = (props) => {
    return (
        <Routes>
            <Route
                exact
                path={"/load/management-panel"}
                element={<ManagementPanel token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/load/driver-binding"}
                element={<DriverBinding token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
        </Routes>
    )
}

export default ManagementPanelRoutes